import { css } from 'styled-components';
// This is an improvement of Math.round.
// It gives you the ability to round after a decimal.
export const roundTo = (n, precision) => Math.round(n * 10 ** precision) / 10 ** precision;
export const size = (width, height = width) => css `
  width: ${width};
  height: ${height};
`;
export const sizePx = (n) => size(`${n}px`);
// eslint-disable-next-line no-shadow
export const propSize = ({ size }) => sizePx(size);
export const propBgColor = ({ color }) => css `
  background-color: ${color};
`;
// eslint-disable-next-line no-shadow
export const propMargin = ({ size = 0 }) => css `
  margin: ${size}px auto;
`;
export const animationDelay = (n) => css `
    animation-delay: ${n}s;
  `;
export const propDelay = ({ delay }) => animationDelay(delay);
export const getRange = (n) => Array.from(new Array(n).keys());
//# sourceMappingURL=index.js.map